export default {
	amex: { icon: 'https://dinova-images-dev.imgix.net/icons/icon-amex.svg', title: 'Amex' },
	mc: { icon: 'https://dinova-images-dev.imgix.net/icons/icon-mc.svg', title: 'Mastercard' },
	discover: { icon: 'https://dinova-images-dev.imgix.net/icons/icon-dc.svg', title: 'Discover' },
	visa: { icon: 'https://dinova-images-dev.imgix.net/icons/icon-visa.svg', title: 'Visa' },
	cash: { icon: 'https://dinova-images-dev.imgix.net/icons/icon-cash.svg', title: 'Cash' }
};
